import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { FormikErrorNotification, FormikTextField } from "@shared";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { useTranslation } from "@/translations";

import { useTranslationToolSettings } from "./hooks/useTranslationToolSettings";

function TranslationToolSettingsInner() {
  const { t } = useTranslation();
  const { formik, isLoading, urlMaxLength } = useTranslationToolSettings();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{ flex: 1, maxHeight: "100%", gap: 1, pb: 1 }}
      bgcolor={"white"}
    >
      <FormikErrorNotification formik={formik} />
      <Stack flex={1} gap={3} sx={{ overflowY: "auto" }}>
        <Typography variant="h5">{t("settings.translationTool.title")}</Typography>
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid size={12}>
            <FormikTextField
              formik={formik}
              fieldName="translationToolUrl"
              label={t("settings.translationTool.url")}
              slotProps={{ input: { inputProps: { maxLength: urlMaxLength } } }}
            />
          </Grid>
        </Grid>
      </Stack>
      <Stack direction="row" justifyContent="space-between" p={0.5}>
        <Button variant="outlined" onClick={formik.handleReset} disabled={formik.isSubmitting || !formik.dirty}>
          {t("common.resetChanges")}
        </Button>
        <Button variant="contained" type="submit" disabled={formik.isSubmitting || !formik.dirty}>
          {t("common.save")}
        </Button>
      </Stack>
    </Stack>
  );
}

export const TranslationToolSettings = withAuthorization(TranslationToolSettingsInner, UserPermission.Supervisor);
